const mediaQuery = window.matchMedia("screen and (max-width: 640px)").matches;

const sleep = (waitTime) =>
  new Promise((resolve) => setTimeout(resolve, waitTime));

const handle = (event) => {
  event.preventDefault();
};

window.addEventListener("load", () => {
  if (window.innerWidth > 768) {
    fvAnimationPc();
  } else {
    fvAnimationSp();
  }
});

window.addEventListener("resize", () => {
  if (window.innerWidth > 768) {
    fvAnimationPc();
  } else {

    const topSectionAllElement = document.querySelectorAll(
      ".Obsidian__FV__Fixed__Sp"
    );
    const topImageWrapperAllElement = document.querySelectorAll(
      ".Obsidian__FV__Image__Wrapper"
    );
    const topImageAllElement = document.querySelectorAll(
      ".Obsidian__FV__Image"
    );
    const conceptBoxElement = document.querySelector(
      ".Obsidian__Concept__Box"
    );
    var vh = window.innerHeight;
    topSectionAllElement.forEach((element) => {
      element.style.height = vh + 1 + "px";
    });
    topImageWrapperAllElement.forEach((element) => {
      element.style.height = vh + 1 + "px";
    });
    topImageAllElement.forEach((element) => {
      element.style.height = vh + 1 + "px";
    });
    conceptBoxElement.style.marginTop = "185px";


    fvAnimationSp();
  }
});

function fvAnimationPc() {
  const topSectionAllElement = document.querySelectorAll(
    ".Obsidian__FV__Fixed"
  );
  const paginationElement = document.querySelector("#pagination");
  const arrowTopElement = document.querySelector(
    ".Obsidian__Pagination__Arrow__Top"
  );
  const currentPaginationElement = document.querySelector(
    ".Obsidian__Pagination__Current"
  );
  const allPaginationElement = document.querySelector(
    ".Obsidian__Pagination__All"
  );
  const arrowBottomElement = document.querySelector(
    ".Obsidian__Pagination__Arrow__Bottom"
  );
  const aboutAreaElement = document.querySelector("#aboutArea");
  const concept1 = document.querySelector(".Obsidian__Concept1");
  const concept2 = document.querySelector(".Obsidian__Concept2");
  const concept3 = document.querySelector(".Obsidian__Concept3");
  const concept4 = document.querySelector(".Obsidian__Concept4");
  const conceptSp1 = document.querySelector(".Obsidian__Concept__sp1");
  const conceptSp2 = document.querySelector(".Obsidian__Concept__sp2");
  const conceptSp3 = document.querySelector(".Obsidian__Concept__sp3");
  const conceptSp4 = document.querySelector(".Obsidian__Concept__sp4");
  const conceptSp5 = document.querySelector(".Obsidian__Concept__sp5");
  const conceptSp6 = document.querySelector(".Obsidian__Concept__sp6");

  const allImageCount = 4;
  const sleepTime = 600;
  const scrollAmount = 150;

  allPaginationElement.innerHTML = "0" + allImageCount;

  let timeoutId;
  let startOffset = 0;
  let processOffset = 0;
  let endOffset = 0;
  let endedScrolling = false;
  let isChangingImage = false;
  let currentImageNum = 1;

  function nextImage() {
    isChangingImage = true;
    if (currentImageNum < allImageCount) {
      topSectionAllElement.forEach((element, index) => {
        if (index <= currentImageNum - 1) {
          element.style.opacity = 0;
          element.style.transform = `translateY(-${scrollAmount}px)`;
        } else {
          element.style.opacity = 1;
        }
      });
      currentImageNum = currentImageNum + 1;
      currentPaginationElement.innerHTML = "0" + currentImageNum;
      if (currentImageNum === allImageCount) {
        arrowBottomElement.disabled = true;
      } else if (currentImageNum == 2) {
        arrowTopElement.disabled = false;
      }
    }

    sleep(sleepTime).then(() => {
      window.scrollTo(0, scrollAmount * (currentImageNum - 1) + 1);
      isChangingImage = false;
      endedScrolling = false;
    });
  }

  function backImage() {
    isChangingImage = true;
    if (currentImageNum > 1) {
      topSectionAllElement.forEach((element, index) => {
        if (index >= currentImageNum - 2) {
          element.style.opacity = 1;
          element.style.transform = "translateY(0px)";
        } else {
          element.style.opacity = 0;
        }
      });
      currentImageNum = currentImageNum - 1;
      currentPaginationElement.innerHTML = "0" + currentImageNum;
      if (currentImageNum == 1) {
        arrowTopElement.disabled = true;
      } else if (currentImageNum == allImageCount - 1) {
        arrowBottomElement.disabled = false;
      }
    }

    sleep(sleepTime).then(() => {
      window.scrollTo(0, scrollAmount * (currentImageNum - 1) + 1);
      isChangingImage = false;
      endedScrolling = false;
    });
  }

  function stayImage() {
    window.scrollTo(0, scrollAmount * (currentImageNum - 1) + 1);
  }

  function fadeUpConcept() {
    // メディアクエリがtrueかどうかをチェック
    if (mediaQuery) {
      conceptSp1.firstElementChild.classList.add("fadeUp");
      conceptSp2.firstElementChild.classList.add("fadeUp");
      conceptSp3.firstElementChild.classList.add("fadeUp");
      conceptSp4.firstElementChild.classList.add("fadeUp");
      conceptSp5.firstElementChild.classList.add("fadeUp");
      conceptSp6.firstElementChild.classList.add("fadeUp");
    } else {
      concept1.firstElementChild.classList.add("fadeUp");
      concept2.firstElementChild.classList.add("fadeUp");
      concept3.firstElementChild.classList.add("fadeUp");
      concept4.firstElementChild.classList.add("fadeUp");
    }
  }

  // 初期化
  function init() {
    if (window.pageYOffset > scrollAmount * (allImageCount - 1) + 50) {
      currentImageNum = allImageCount;

      startOffset = 0;
      processOffset = window.pageYOffset;
      topSectionAllElement[currentImageNum - 1].classList.add("ended");
      paginationElement.classList.remove("Obsidian__FV__Transition");
      paginationElement.style.opacity = 0;
      topSectionAllElement.forEach((element, index) => {
        if (index != allImageCount - 1) {
          element.style.zIndex = 0;
          element.classList.remove("Obsidian__FV__Transition");
          element.style.opacity = 0;
          sleep(sleepTime).then(() => {
            element.classList.add("Obsidian__FV__Transition");
            paginationElement.classList.add("Obsidian__FV__Transition");
          });
        }
      });
    } else {
      window.scrollTo(0, 0);
    }
  }
  init();

  // ページネーションクリックイベント

  arrowTopElement.addEventListener("click", () => {
    backImage();
  });
  arrowBottomElement.addEventListener("click", () => {
    nextImage();
  });

  // MAIN スクロールイベント

  window.addEventListener("scroll", function () {
    if (!endedScrolling) {
      startOffset = window.pageYOffset;
      endedScrolling = true;
    }
    processOffset = window.pageYOffset;

    // 画像が切り替わるとき
    if (!isChangingImage) {
      if (currentImageNum == allImageCount) {
        if (processOffset > 150 * (allImageCount - 1) + 1) {
          topSectionAllElement[currentImageNum - 1].classList.add("ended");
          paginationElement.style.opacity = 0;
          topSectionAllElement.forEach((element, index) => {
            if (index != allImageCount - 1) {
              element.style.zIndex = 0;
              element.style.display = "block";
            }
          });

          if (processOffset > 150 * (allImageCount - 1) + 400) {
            fadeUpConcept();
            topSectionAllElement.forEach((element, index) => {
              if (index != allImageCount - 1) {
                element.style.zIndex = 0;
                element.style.display = "none"
              }
            });
          }
        } else if (processOffset < 150 * (allImageCount - 1)) {
          topSectionAllElement[currentImageNum - 1].classList.remove("ended");
          paginationElement.style.opacity = 1;
          topSectionAllElement.forEach((element, index) => {
            if (index != allImageCount - 1) {
              element.style.zIndex = 6 - index;
            }
          });
          backImage();
        }
      } else if (processOffset - startOffset > scrollAmount) {
        // 次の画像へ
        nextImage();
        return;
      } else if (startOffset - processOffset > scrollAmount) {
        // 前の画像へ
        backImage();
        return;
      } else if (currentImageNum != allImageCount) {
        // 画像そのまま
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
          if (!isChangingImage) {
            endOffset = window.pageYOffset;
            stayImage();
            endedScrolling = false;
          }
        }, 100);
      }
    }
  });
}

// ========================================================
// ========================================================
// SP
// ========================================================
// ========================================================

function fvAnimationSp() {
  let currentShowedImage = 1;
  const scrolldownElement = document.querySelector("#scrolldownSp");
  const topSection1Element = document.querySelector(
    ".Obsidian__FV__Section__SP1"
  );
  const topSection2Element = document.querySelector(
    ".Obsidian__FV__Section__SP2"
  );
  const topSection3Element = document.querySelector(
    ".Obsidian__FV__Section__SP3"
  );
  const topSection4Element = document.querySelector(
    ".Obsidian__FV__Section__SP4"
  );
  const topSection5Element = document.querySelector(
    ".Obsidian__FV__Section__SP5"
  );
  const topSection6Element = document.querySelector(
    ".Obsidian__FV__Section__SP6"
  );
  const topSectionAllElement = document.querySelectorAll(
    ".Obsidian__FV__Fixed__Sp"
  );
  const topAreaAllElement = document.querySelectorAll(
    ".Obsidian__FV__Area__Sp"
  );
  const paginationElement = document.querySelector("#paginationSp");
  const arrowTopElement = document.querySelector("#paginationArrowTopSp");
  const currentPaginationElement = document.querySelector(
    "#paginationCurrentSp"
  );
  const allPaginationElement = document.querySelector("#paginationAllSp");
  const arrowBottomElement = document.querySelector("#paginationArrowBottomSp");
  const allImageCount = 6;
  const sleepTime = 600;

  allPaginationElement.innerHTML = "0" + allImageCount;
  var vh = window.innerHeight;
  topSectionAllElement.forEach((element) => {
    element.style.height = vh + "px";
  });

  function handleAreaOpacity(elementNum) {
    topAreaAllElement.forEach((element, index) => {
      if (index <= elementNum) {
        element.style.opacity = 0;
        return;
      }
      element.style.opacity = 1;
    });
  }

  function initSectionZIndex() {
    topSectionAllElement.forEach((element, index) => {
      element.style.zIndex = allImageCount - index;
    });
  }

  function changeImage(nextNum, scrollAmount) {
    document.addEventListener("touchmove", handle, { passive: false });
    window.scrollTo(0, scrollAmount);

    sleep(sleepTime).then(() => {
      currentShowedImage = nextNum;
      document.removeEventListener("touchmove", handle, { passive: false });
    });
  }

  function changeImageShort(nextNum, scrollAmount) {
    document.addEventListener("touchmove", handle, { passive: false });
    window.scrollTo(0, scrollAmount);

    sleep(sleepTime/3).then(() => {
      currentShowedImage = nextNum;
      document.removeEventListener("touchmove", handle, { passive: false });
    });
  }

  function handleSection6Fixed() {
    topSection6Element.style.position = "fixed";
    topSection6Element.style.marginTop = "0px";
  }

  function changePagination(num) {
    currentPaginationElement.innerHTML = "0" + num;
    if (num === 1) {
      arrowTopElement.style.opacity = 0.5;
    } else {
      arrowTopElement.style.opacity = 1;
    }
    if (num === allImageCount) {
      arrowBottomElement.style.opacity = 0.5;
    } else {
      arrowBottomElement.style.opacity = 1;
    }
    paginationElement.style.opacity = 1;
  }

  // 初期化

  function initFV() {
    currentShowedImage = 6;
    handleAreaOpacity(4);
    topSection1Element.style.zIndex = -1;
    topSection2Element.style.zIndex = -1;
    topSection3Element.style.zIndex = -1;
    topSection4Element.style.zIndex = -1;
    topSection5Element.style.zIndex = -1;
    topSection6Element.style.position = "relative";
    topSection6Element.style.marginTop = "500px";

    // ページネーション
    paginationElement.style.opacity = 0;
    // スクロールダウン
    scrolldownElement.style.opacity = 0;
  }

  if (window.pageYOffset >= 650) {
    initFV();
  }

  // ページネーションイベント
  function handleClickEvent() {
    arrowTopElement.disabled = true;
    arrowBottomElement.disabled = true;

    sleep(sleepTime).then(() => {
      arrowTopElement.disabled = false;
      arrowBottomElement.disabled = false;
    });
  }

  arrowTopElement.addEventListener("click", () => {
    if (currentShowedImage === 1) {
      return;
    } else if (currentShowedImage === 2) {
      handleClickEvent();
      changeImage(1, 0);
      handleAreaOpacity(0);
      initSectionZIndex();
      changePagination(1);
    } else if (currentShowedImage === 3) {
      handleClickEvent();
      changeImage(2, 105);
      handleAreaOpacity(1);
      initSectionZIndex();
      changePagination(2);
    } else if (currentShowedImage === 4) {
      handleClickEvent();
      changeImage(3, 205);
      handleAreaOpacity(2);
      initSectionZIndex();
      changePagination(3);
    } else if (currentShowedImage === 5) {
      handleClickEvent();
      changeImage(4, 305);
      handleAreaOpacity(3);
      initSectionZIndex();
      changePagination(4);
    } else if (currentShowedImage === 6) {
      handleClickEvent();
      changeImage(5, 405);
      handleAreaOpacity(4);
      initSectionZIndex();
      changePagination(5);
    }
  });

  arrowBottomElement.addEventListener("click", () => {
    if (currentShowedImage === 1) {
      handleClickEvent();
      changeImage(2, 100);
      handleAreaOpacity(1);
      initSectionZIndex();
      changePagination(2);
    } else if (currentShowedImage === 2) {
      handleClickEvent();
      changeImage(3, 205);
      handleAreaOpacity(2);
      initSectionZIndex();
      changePagination(3);
    } else if (currentShowedImage === 3) {
      handleClickEvent();
      changeImage(4, 305);
      handleAreaOpacity(3);
      initSectionZIndex();
      changePagination(4);
    } else if (currentShowedImage === 4) {
      handleClickEvent();
      changeImage(5, 405);
      handleAreaOpacity(4);
      initSectionZIndex();
      changePagination(5);
    } else if (currentShowedImage === 5) {
      handleClickEvent();
      changeImage(6, 505);
      handleAreaOpacity(5);
      initSectionZIndex();
      changePagination(6);
    } else if (currentShowedImage === 6) {
      return;
    }
  });

  // main スクロールイベント

  window.onscroll = function () {
    let startPosition = window.pageYOffset;
    if (startPosition < 100) {
      if (currentShowedImage === 3) {
        changeImage(2, 200);
      } else if (currentShowedImage == 4) {
        changeImage(3, 300);
      } else if (currentShowedImage == 5) {
        changeImage(4, 400);
      } else if (currentShowedImage == 6) {
        changeImage(5, 500);
      }
      currentShowedImage = 1;
      // 画像切り替え 1枚目
      handleAreaOpacity(-1);
      initSectionZIndex();
      // ページネーション
      changePagination(1);
    } else if (startPosition < 205) {
      // 画像切り替え 2枚目
      if (currentShowedImage === 1) {
        changeImageShort(2, 100);
      } else if (currentShowedImage === 3) {
        changeImage(2, 200);
      } else if (currentShowedImage == 4) {
        changeImage(3, 300);
      } else if (currentShowedImage == 5) {
        changeImage(4, 400);
      } else if (currentShowedImage == 6) {
        changeImage(5, 500);
      }
      handleAreaOpacity(0);
      initSectionZIndex();
      // ページネーション
      changePagination(2);
    } else if (startPosition >= 200 && startPosition < 303) {
      // 画像切り替え 3枚目
      if (currentShowedImage === 1) {
        changeImage(2, 100);
      } else if (currentShowedImage === 2) {
        changeImage(3, 205);
      } else if (currentShowedImage == 4) {
        changeImage(3, 300);
      } else if (currentShowedImage == 5) {
        changeImage(4, 400);
      } else if (currentShowedImage == 6) {
        changeImage(5, 500);
      }
      handleAreaOpacity(1);
      initSectionZIndex();
      handleSection6Fixed();
      // ページネーション
      changePagination(3);
    } else if (startPosition >= 300 && startPosition < 403) {
      // 画像切り替え 4枚目
      if (currentShowedImage === 1) {
        changeImage(2, 100);
      } else if (currentShowedImage === 2) {
        changeImage(3, 205);
      } else if (currentShowedImage === 3) {
        changeImage(4, 305);
      } else if (currentShowedImage == 5) {
        changeImage(4, 400);
      } else if (currentShowedImage == 6) {
        changeImage(5, 500);
      }
      handleAreaOpacity(2);
      initSectionZIndex();
      handleSection6Fixed();
      // ページネーション
      changePagination(4);
    } else if (startPosition >= 400 && startPosition < 503) {
      // 画像切り替え 5枚目
      if (currentShowedImage === 1) {
        changeImage(2, 100);
      } else if (currentShowedImage === 2) {
        changeImage(3, 205);
      } else if (currentShowedImage === 3) {
        changeImage(4, 305);
      } else if (currentShowedImage === 4) {
        changeImage(5, 405);
      } else if (currentShowedImage == 6) {
        changeImage(5, 500);
      }
      handleAreaOpacity(3);
      initSectionZIndex();
      handleSection6Fixed();
      // ページネーション
      changePagination(5);
    } else if (startPosition >= 500 && startPosition < 650) {
      // 画像切り替え 6枚目
      if (currentShowedImage === 1) {
        changeImage(2, 100);
      } else if (currentShowedImage === 2) {
        changeImage(3, 200);
      } else if (currentShowedImage === 3) {
        changeImage(4, 300);
      } else if (currentShowedImage === 4) {
        changeImage(5, 400);
      } else if (currentShowedImage == 5) {
        changeImage(6, 505);
      }
      handleAreaOpacity(4);
      initSectionZIndex();
      handleSection6Fixed();
      if (currentShowedImage == 6) {
        topSection6Element.style.position = "relative";
        topSection6Element.style.marginTop = "500px";
      }
      // ページネーション
      changePagination(6);
    } else if (startPosition >= 650) {
      // 画像切り替え last
      if (currentShowedImage === 1) {
        changeImage(2, 100);
      } else if (currentShowedImage === 2) {
        changeImage(3, 200);
      } else if (currentShowedImage === 3) {
        changeImage(4, 300);
      } else if (currentShowedImage === 4) {
        changeImage(5, 400);
      } else if (currentShowedImage == 5) {
        changeImage(6, 500);
      }
      handleAreaOpacity(4);
      topSection1Element.style.zIndex = -1;
      topSection2Element.style.zIndex = -1;
      topSection3Element.style.zIndex = -1;
      topSection4Element.style.zIndex = -1;
      topSection5Element.style.zIndex = -1;
      topSection6Element.style.position = "relative";
      topSection6Element.style.marginTop = "500px";
      // ページネーション
      paginationElement.style.opacity = 0;
    }
  };


  // ========================================================
  // ========================================================
  // 感度高めのスクロールイベント
  // ========================================================
  // ========================================================

  // let currentShowedImage = 1;

  // const topSectionAllElement = document.querySelectorAll(
  //   ".Obsidian__FV__Fixed__Sp"
  // );
  // const paginationElement = document.querySelector("#paginationSp");
  // const arrowTopElement = document.querySelector("#paginationArrowTopSp");
  // const currentPaginationElement = document.querySelector(
  //   "#paginationCurrentSp"
  // );
  // const allPaginationElement = document.querySelector("#paginationAllSp");
  // const arrowBottomElement = document.querySelector("#paginationArrowBottomSp");
  // const aboutAreaElement = document.querySelector("#aboutArea");
  // const concept1 = document.querySelector(".Obsidian__Concept1");
  // const concept2 = document.querySelector(".Obsidian__Concept2");
  // const concept3 = document.querySelector(".Obsidian__Concept3");
  // const concept4 = document.querySelector(".Obsidian__Concept4");
  // const conceptSp1 = document.querySelector(".Obsidian__Concept__sp1");
  // const conceptSp2 = document.querySelector(".Obsidian__Concept__sp2");
  // const conceptSp3 = document.querySelector(".Obsidian__Concept__sp3");
  // const conceptSp4 = document.querySelector(".Obsidian__Concept__sp4");
  // const conceptSp5 = document.querySelector(".Obsidian__Concept__sp5");
  // const conceptSp6 = document.querySelector(".Obsidian__Concept__sp6");

  // const allImageCount = 6;
  // const sleepTime = 600;
  // const scrollAmount = 100;

  // console.log("loadedSP");
  // allPaginationElement.innerHTML = "0" + allImageCount;

  // let timeoutId;
  // let startOffset = 0;
  // let processOffset = 0;
  // let endOffset = 0;
  // let endedScrolling = false;
  // let isChangingImage = false;
  // let currentImageNum = 1;

  // function nextImage() {
  //   console.log("次の画像へ 100over");
  //   isChangingImage = true;
  //   if (currentImageNum < allImageCount) {
  //     topSectionAllElement.forEach((element, index) => {
  //       if (index <= currentImageNum - 1) {
  //         element.style.opacity = 0;
  //         // element.style.transform = `translateY(-${scrollAmount}px)`;
  //       } else {
  //         element.style.opacity = 1;
  //       }
  //     });
  //     currentImageNum = currentImageNum + 1;
  //     currentPaginationElement.innerHTML = "0" + currentImageNum;
  //     if (currentImageNum === allImageCount) {
  //       arrowBottomElement.disabled = true;
  //     } else if (currentImageNum == 2) {
  //       arrowTopElement.disabled = false;
  //     }
  //   }

  //   sleep(sleepTime).then(() => {
  //     window.scrollTo(0, scrollAmount * (currentImageNum - 1) + 1);
  //     isChangingImage = false;
  //     endedScrolling = false;
  //     console.log(
  //       "画像切り替え終了",
  //       currentImageNum,
  //       startOffset,
  //       processOffset
  //     );
  //   });
  // }

  // function backImage() {
  //   console.log("前の画像へ -100over");
  //   isChangingImage = true;
  //   if (currentImageNum > 1) {
  //     topSectionAllElement.forEach((element, index) => {
  //       if (index >= currentImageNum - 2) {
  //         element.style.opacity = 1;
  //         // element.style.transform = "translateY(0px)";
  //       } else {
  //         element.style.opacity = 0;
  //       }
  //     });
  //     currentImageNum = currentImageNum - 1;
  //     currentPaginationElement.innerHTML = "0" + currentImageNum;
  //     if (currentImageNum == 1) {
  //       arrowTopElement.disabled = true;
  //     } else if (currentImageNum == allImageCount - 1) {
  //       arrowBottomElement.disabled = false;
  //     }
  //   }

  //   sleep(sleepTime).then(() => {
  //     window.scrollTo(0, scrollAmount * (currentImageNum - 1) + 1);
  //     isChangingImage = false;
  //     endedScrolling = false;
  //     console.log(
  //       "画像切り替え終了",
  //       currentImageNum,
  //       startOffset,
  //       processOffset
  //     );
  //   });
  // }

  // function stayImage() {
  //   console.log("scrollEND 画像そのまま", startOffset, endOffset);
  //   window.scrollTo(0, scrollAmount * (currentImageNum - 1) + 1);
  // }

  // function fadeUpConcept() {
  //   // メディアクエリがtrueかどうかをチェック
  //   if (mediaQuery) {
  //     conceptSp1.firstElementChild.classList.add("fadeUp");
  //     conceptSp2.firstElementChild.classList.add("fadeUp");
  //     conceptSp3.firstElementChild.classList.add("fadeUp");
  //     conceptSp4.firstElementChild.classList.add("fadeUp");
  //     conceptSp5.firstElementChild.classList.add("fadeUp");
  //     conceptSp6.firstElementChild.classList.add("fadeUp");
  //   } else {
  //     concept1.firstElementChild.classList.add("fadeUp");
  //     concept2.firstElementChild.classList.add("fadeUp");
  //     concept3.firstElementChild.classList.add("fadeUp");
  //     concept4.firstElementChild.classList.add("fadeUp");
  //   }
  // }

  // // 初期化
  // function init() {
  //   var vh = window.innerHeight;
  //   topSectionAllElement.forEach((element) => {
  //     element.style.height = vh + "px";
  //   });

  //   if (window.pageYOffset > scrollAmount * (allImageCount - 1) + 50) {
  //     console.log("初期化");
  //     currentImageNum = allImageCount;

  //     startOffset = 0;
  //     processOffset = window.pageYOffset;
  //     topSectionAllElement[currentImageNum - 1].classList.add("ended");
  //     paginationElement.classList.remove("Obsidian__FV__Transition");
  //     paginationElement.style.opacity = 0;
  //     topSectionAllElement.forEach((element, index) => {
  //       if (index != allImageCount - 1) {
  //         element.style.zIndex = 0;
  //         element.classList.remove("Obsidian__FV__Transition");
  //         element.style.opacity = 0;
  //         sleep(sleepTime).then(() => {
  //           element.classList.add("Obsidian__FV__Transition");
  //           paginationElement.classList.add("Obsidian__FV__Transition");
  //         });
  //       }
  //     });
  //   } else {
  //     window.scrollTo(0, 0);
  //   }
  //   setTimeout("scrollTo(0,1)", 100);
  // }
  // init();

  // // ページネーションクリックイベント

  // arrowTopElement.addEventListener("click", () => {
  //   backImage();
  // });
  // arrowBottomElement.addEventListener("click", () => {
  //   nextImage();
  // });

  // // MAIN スクロールイベント

  // window.addEventListener("scroll", function () {
  //   if (!endedScrolling) {
  //     startOffset = window.pageYOffset;
  //     endedScrolling = true;
  //   }
  //   processOffset = window.pageYOffset;

  //   // 画像が切り替わるとき
  //   if (!isChangingImage) {
  //     if (currentImageNum == allImageCount) {
  //       if (processOffset > scrollAmount * (allImageCount - 1) + 1) {
  //         console.log("最後の画像で下にスクロール", processOffset);
  //         topSectionAllElement[currentImageNum - 1].classList.add("ended");
  //         paginationElement.style.opacity = 0;
  //         topSectionAllElement.forEach((element, index) => {
  //           if (index != allImageCount - 1) {
  //             element.style.zIndex = 0;
  //           }
  //         });

  //         if (processOffset > scrollAmount * (allImageCount - 1) + 200) {
  //           fadeUpConcept();
  //         }
  //       } else if (processOffset < scrollAmount * (allImageCount - 1)) {
  //         console.log("最後の画像で上にスクロール");
  //         topSectionAllElement[currentImageNum - 1].classList.remove("ended");
  //         paginationElement.style.opacity = 1;
  //         topSectionAllElement.forEach((element, index) => {
  //           if (index != allImageCount - 1) {
  //             element.style.zIndex = 6 - index;
  //           }
  //         });
  //         backImage();
  //       }
  //     } else if (processOffset - startOffset > scrollAmount) {
  //       // 次の画像へ
  //       nextImage();
  //       return;
  //     } else if (startOffset - processOffset > scrollAmount) {
  //       // 前の画像へ
  //       backImage();
  //       return;
  //     } else if (currentImageNum != allImageCount) {
  //       // 画像そのまま
  //       clearTimeout(timeoutId);
  //       timeoutId = setTimeout(function () {
  //         if (!isChangingImage) {
  //           endOffset = window.pageYOffset;
  //           // stayImage();
  //           endedScrolling = false;
  //         }
  //       }, 100);
  //     }
  //   }
  // });

  // ==============
  // touch版
  // ==============

  // document.addEventListener("touchstart", () => {
  //   window.onscroll = function () {
  //     if (currentShowedImage === 1) {
  //       topSection1Element.style.transform = `translateY(-${window.pageYOffset}px)`;
  //       console.log("1", window.pageYOffset, currentShowedImage);
  //     } else if (currentShowedImage === 2) {
  //       topSection2Element.style.transform = `translateY(-${
  //         window.pageYOffset - 100
  //       }px)`;
  //       console.log("2", window.pageYOffset, currentShowedImage);
  //     } else if (currentShowedImage === 3) {
  //       topSection3Element.style.transform = `translateY(-${
  //         window.pageYOffset - 200
  //       }px)`;
  //       console.log("3", window.pageYOffset, currentShowedImage);
  //     } else if (currentShowedImage === 4) {
  //       topSection4Element.style.transform = `translateY(-${
  //         window.pageYOffset - 300
  //       }px)`;
  //       console.log("4", window.pageYOffset, currentShowedImage);
  //     } else if (currentShowedImage === 5) {
  //       topSection5Element.style.transform = `translateY(-${
  //         window.pageYOffset - 400
  //       }px)`;
  //       console.log("5", window.pageYOffset, currentShowedImage);
  //     }
  //   };
  // });

  // function stayImage(element, scrollAmount) {
  //   console.log("stay", scrollAmount);
  //   element.classList.add("smooth");
  //   document.addEventListener("touchstart", handle, { passive: false });
  //   window.scrollTo(0, scrollAmount);
  //   sleep(600).then(() => {
  //     element.classList.remove("smooth");
  //     document.removeEventListener("touchstart", handle, { passive: false });
  //   });
  // }

  // function nextImage(element, nextImageNum, scrollAmount, paginationNum) {
  //   currentShowedImage = nextImageNum;
  //   element.style.opacity = 0;
  //   currentPaginationElement.innerHTML = paginationNum;
  //   if (nextImageNum == 6) {
  //     arrowBottomElement.style.opacity = 0.5;
  //   } else {
  //     arrowTopElement.style.opacity = 1;
  //     arrowBottomElement.style.opacity = 1;
  //   }
  //   document.addEventListener("touchstart", handle, { passive: false });
  //   sleep(600).then(() => {
  //     document.removeEventListener("touchstart", handle, { passive: false });
  //     window.scrollTo(0, scrollAmount);
  //   });
  // }

  // function backImage(element, backImageNum, scrollAmount, paginationNum) {
  //   currentShowedImage = backImageNum;
  //   window.scrollTo(0, scrollAmount);
  //   element.style.opacity = 1;
  //   currentPaginationElement.innerHTML = paginationNum;
  //   if (backImageNum == 1) {
  //     arrowTopElement.style.opacity = 0.5;
  //   } else {
  //     arrowTopElement.style.opacity = 1;
  //     arrowBottomElement.style.opacity = 1;
  //   }
  //   document.addEventListener("touchstart", handle, { passive: false });
  //   sleep(600).then(() => {
  //     document.removeEventListener("touchstart", handle, { passive: false });
  //     window.scrollTo(0, scrollAmount);
  //   });
  // }

  // document.addEventListener("touchend", () => {
  //   if (currentShowedImage == 1) {
  //     if (window.pageYOffset < 100) {
  //       stayImage(topSection1Element, 100 * (currentShowedImage - 1));
  //     } else {
  //       nextImage(topSection1Element, currentShowedImage + 1, 100 * currentShowedImage, "02");
  //     }
  //   } else if (currentShowedImage == 2) {
  //     if (window.pageYOffset < 100) {
  //       backImage(topSection1Element, currentShowedImage - 1, 100 * (currentShowedImage - 2), "01");
  //     } else if (window.pageYOffset < 200) {
  //       stayImage(topSection2Element, 100 * (currentShowedImage - 1));
  //     } else {
  //       nextImage(topSection2Element, currentShowedImage + 1, 100 * currentShowedImage, "03");
  //     }
  //   } else if (currentShowedImage == 3) {
  //     if (window.pageYOffset < 200) {
  //       backImage(topSection2Element, currentShowedImage - 1, 100 * (currentShowedImage - 2), "02");
  //     } else if (window.pageYOffset < 300) {
  //       stayImage(topSection3Element, 100 * (currentShowedImage - 1));
  //     } else {
  //       nextImage(topSection3Element, currentShowedImage + 1, 100 * currentShowedImage, "04");
  //     }
  //   } else if (currentShowedImage == 4) {
  //     if (window.pageYOffset < 300) {
  //       backImage(topSection3Element, currentShowedImage - 1, 100 * (currentShowedImage - 2, "03"));
  //     } else if (window.pageYOffset < 400) {
  //       stayImage(topSection4Element, 100 * (currentShowedImage - 1));
  //     } else {
  //       nextImage(topSection4Element, currentShowedImage + 1, 100 * currentShowedImage, "05");
  //     }
  //   } else if (currentShowedImage == 5) {
  //     if (window.pageYOffset < 400) {
  //       backImage(topSection4Element, currentShowedImage - 1, 100 * (currentShowedImage - 2), "04");
  //     } else if (window.pageYOffset < 500) {
  //       stayImage(topSection5Element, 100 * (currentShowedImage - 1));
  //     } else {
  //       nextImage(topSection5Element, currentShowedImage + 1, 100 * currentShowedImage, "06");
  //     }
  //   }
  // });
}
